import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { ExtraType } from "../../../../../common-deprecated/types/CommonTypes";
import type { SortedSpecType } from "../../../../../common-deprecated/types/SpecTypes";
import type { FetchSpecsEquipmentDataType } from "../../../../shared-logic/server/data/FetchSpecifications";

export type SpecStateType = {
    initialized: boolean;
    techSpecs: SortedSpecType[];
    standardEquipment: ExtraType[];
};

export const initialState: SpecStateType = {
    initialized: false,
    techSpecs: [],
    standardEquipment: [],
};

export type CarConfigSpecActionTypes = ReturnType<typeof setSpecs>;

export const CarConfigSpecSlice = createSlice({
    name: "specs",
    initialState,
    reducers: {
        setSpecs(state, action: PayloadAction<FetchSpecsEquipmentDataType>) {
            const { techSpecs, standardEquipment } = action.payload;
            return {
                ...state,
                techSpecs,
                standardEquipment,
                initialized: true,
            };
        },
    },
});

export const { setSpecs } = CarConfigSpecSlice.actions;
